module.exports = __webpack_public_path__ + "static/img/video4.5211defc.png";